import favicon from 'assets/images/favicon.png';

const title = 'Baja California Wine Tours';
const description =
  'All inclusive mexican wine tasting trips from SoCal to Valle de Guadalupe in Baja California';

export const helmet = {
  title,
  titleTemplate: '%s - Ruadeseo',
  htmlAttributes: { lang: 'en' },
  meta: [
    { name: 'description', content: description },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, user-scalable=no',
    },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black' },
    { name: 'msapplication-navbutton-color', content: '#000' },
    { name: 'msapplication-TileColor', content: '#000' },
    { name: 'theme-color', content: '#000' },

    { property: 'og:title', content: title },
    {
      property: 'og:image',
      content:
        'https://aihsvmgxxq.cloudimg.io/v7/ruadeseo.s3.us-west-1.amazonaws.com/finca-cheers-2.jpg?width=500',
    },
    { property: 'og:image:width', content: '880px' },
    { property: 'og:image:height', content: '440px' },
    { property: 'og:image:alt', content: description },

    { name: 'twitter:title', content: title },
    { name: 'twitter:card', content: 'summary_large_image' },
    {
      name: 'twitter:image',
      content:
        'https://aihsvmgxxq.cloudimg.io/v7/ruadeseo.s3.us-west-1.amazonaws.com/finca-cheers-2.jpg?width=500',
    },
    { name: 'twitter:site', content: '@uenodotco' },
    { name: 'twitter:creator', content: '@uenodotco' },
    { name: 'twitter:description', content: description },
  ],
  link: [{ rel: 'icon', type: 'image/x-icon', href: favicon }],
};
